import ApiService from "@/common/api.service";
import JwtService from "@/common/jwt.service";
import {VERSION} from "@/common/version";
import moment from "moment";
import {
  LOGIN,
  SET_ERRORS,
  LOGOUT,
  CHECK_AUTH,
  REFRESH_TOKEN
} from "./actions.type";
import { 
  SET_AUTH,
  PURGE_AUTH,
  SET_ERROR,
  REFRESH,
  SET_TABLE_DATA
} from "./mutations.type";

const getSetVersion = function() {
    let local_version = JwtService.getVersion();

    if(local_version !== VERSION){
        console.log('Change Version Block')
        JwtService.saveVersion(VERSION);
        window.location.reload(true)
    }
    return VERSION
}

const state = {
  errors: null,
  user: JwtService.getUser(),
  version: null,
  isAuthenticated: !!JwtService.getToken(),
  planStatus: JwtService.getPlanStatus(),
  shiftsTableData: null
};

const getters = {
  currentUser(state) {
    return state.user;
  },
  user(state) {
    return state.user;
  },
  isAuthenticated(state) {
    return state.isAuthenticated;
  },
  subscriptionPackage() {
    if (state.user !== null && state.user.subscription_package !== null) {
      return state.user.subscription_package;
    } else {
      return null;
    }
  },
  organizationId() {
    if (state.user !== null) {
      return state.user.organization_id;
    } else {
      return null;
    }
  },
  permissions() {
    let permissions = [
      "dashboard",
      "change_password",
      "change_email",
      "credit_cards",
      "web_ads",
      "print_digital_ads",
      "newsletter",
      "trainings",
      "training_show",
      "reports",
      "company_profiles",
      "article",
      "block",
      "leaderboard_mob",
      "leaderboard_web",
      "sticky",
      "sticky_mob",
      "admin_advertisers",
      "admin_trainings",
      "admin_categories",
      "admin_category_details",
      "admin_advertiser_details",
      "admin_training_details",
      "admin_web_ads",
      "admin_newsletter",
      "admin_newsletters",
      "admin_newsletter_details",
      "admin_print_digital_ads",
      "admin_credit_cards",
      "admin_reports",
      "service_plans",
      "service_plan_details",
      "subscriptions",
      "subscription_details",
      "print_issues",
      "print_digital_issues",
      "admin_product_guide",
      "product_guide",
    ]
    if (state.user !== null && state.user.role && state.user.role !== 'admin') {
      let admin_permissions = [
        "admin_advertisers",
        "admin_trainings",
        "admin_categories",
        "admin_category_details",
        "admin_advertiser_details",
        "admin_training_details",
        "admin_web_ads",
        "admin_newsletter",
        "admin_newsletters",
        "admin_newsletter_details",
        "admin_print_digital_ads",
        "admin_credit_cards",
        "admin_reports",
        "service_plans",
        "service_plan_details",
        "subscriptions",
        "subscription_details",
        "print_issues",
        "print_digital_issues",
        "admin_product_guide",
      ]
      permissions = permissions.filter(i => !admin_permissions.includes(i))
    }
    if (state.user !== null && state.user.permissions && typeof state.user.permissions === 'object') {
      let not_permited = Object.entries(state.user.permissions).filter(i => i[1] != 1).map(i => i[0])
      permissions = permissions.filter(i => !not_permited.includes(i))
      
      let banner_permissions = [
        "article",
        "block",
        "leaderboard_mob",
        "leaderboard_web",
        "sticky",
        "sticky_mob"
      ]
      if(!permissions.some(i => banner_permissions.includes(i))) {
        permissions = permissions.filter(i => i !== 'web_ads')
      }
    }
    return permissions
  }
};

const actions = {
  [LOGIN](context, credentials) {
    return new Promise((resolve, reject) => {
      ApiService.put("login", credentials)
        .then(({ data }) => {
            if(data.token){
                context.commit(SET_AUTH, data);
              resolve(data);
            }else{
                context.commit(SET_ERROR, data);
                reject(data);
            }
        })
        .catch(error => {
          console.log(error);
          reject(error);
        })
    });
  },
  [LOGOUT](context) {
    context.commit(PURGE_AUTH);
  },
  [SET_ERRORS](context, errors) {
    context.commit(SET_ERROR, errors);
  },
  [CHECK_AUTH](context, token) {
    return new Promise((resolve, reject) => {
      if (JwtService.getToken() || token) {
        if (token) {
          ApiService.setHeader(token);
        } else {
          ApiService.setHeader();
        }
          ApiService.get("/auth/employee_user")
            .then(({ data }) => {
              context.commit(SET_AUTH, data);
              resolve(data);
            })
            .catch(({ response }) => {
              context.commit(SET_ERROR, response.data.errors);
              reject(response);
            })
      } else {
        context.commit(PURGE_AUTH);
        reject();
      }
    });
  },
  [REFRESH_TOKEN](context, token) {
    return new Promise((resolve, reject) => {
      ApiService.put("/refresh_token")
        .then(response => {
          console.log(response);
          JwtService.saveToken(response.data.token);
          resolve(response);
        })
        .catch(({ response }) => {
          context.commit(SET_ERROR, response.data.errors);
          reject(response);
        })
    });
  },
};

const mutations = {
  [SET_ERROR](state, error) {
    state.errors = error;
  },
  [SET_AUTH](state, user) {
    state.isAuthenticated = true;
    state.user = { ...user.user };
    state.errors = null;
    JwtService.saveToken(user.token);
    JwtService.saveOrganizationId(user.user.organization_id);
    JwtService.saveUser(user.user);
  },
  updateUser (state, user) {
    state.user = { ...state.user, ...user }
    JwtService.saveUser({ ...state.user, ...user })
  }, 
  [PURGE_AUTH](state) {
    state.isAuthenticated = false;
    state.user = {};
    state.errors = null;
    JwtService.destroyToken();
    JwtService.destroyOrganizationId();
    JwtService.destroyOrganizationToken();
    JwtService.destroyUser();
  },
  [REFRESH](state) {
    state.version = getSetVersion();
  },
  [SET_TABLE_DATA](state, data) {
    state[data.key] = data.value
  }
};

export default {
  state,
  actions,
  mutations,
  getters
};
